import { technologies } from '@/shared/consts/siteData'
import { oldFilters } from '@/shared/types/oldFilters'
import {
  AllDataFromSalesForce,
  allOldData,
  SingleCompanyResultSalesForce,
  StoryRawFromSalesForce,
} from '@/shared/types/allOldData'
import { allOldStoriesById } from '@/shared/types/allOldStoriesById'
import { cache } from 'react'
import {
  ApiMetaData,
  ApiTheme,
  Card,
  FilterValuesObject,
  Portfolio,
  SalesforceMetaData,
  StoryFormatted,
} from '@/constants/t'
import { StoryPublishedRenderDtoResponse, FilterDataFromApi, DesignRenderDto } from '@/utils/ttt'
import { restructureOldStoriesData, RestructuredOldStoriesDataItem, RestructureDesign } from '@/utils/formaters'
import { toCanonical } from '@repo/utils'

// import fs from 'fs/promises'
// import path from 'path'
export const convertIntoDashedString = (raw: string): string => {
  return toCanonical(raw)
}
// export const convertIntoDashedString = (data: string) => {
//   return data
//     .trim()
//     .replace(/[^A-Z0-9]+/gi, '-')
//     .toLowerCase()
// }

export const getRandomizedFilteredCards = (filteredCards: any[]) => {
  if (filteredCards.length === 0) {
    return filteredCards
  }
  const randomizedCards = [...filteredCards]
  for (let i = randomizedCards.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[randomizedCards[i], randomizedCards[j]] = [randomizedCards[j], randomizedCards[i]]
  }

  return randomizedCards
}

export const getSortedFilteredCards = (cards: any[]) => {
  if (cards.length === 0) {
    return cards
  }

  const sortedCards = cards.sort((a, b) => new Date(b.date) - new Date(a.date))

  const result = sortedCards.reduce(
    (acc, card) => {
      if (card.isSalesforce) {
        acc.salesforce.push(card)
      } else {
        acc.others.push(card)
      }
      return acc
    },
    { salesforce: [], others: [] },
  )

  return [...result.others, ...result.salesforce]
}

export function covertCommaSeparatedToArray(obj: string, separation: string) {
  return obj?.length > 0 ? obj?.split(separation) : []
}

export function convertArrayToCommaSeparatedString(obj: any, key: string, separation: string) {
  if (obj[key] && Array.isArray(obj[key])) {
    return obj[key].join(separation)
  }

  return ''
}

export function hexToRgba(hex: string, alpha = 1) {
  hex = hex.replace(/^#/, '')
  let r = parseInt(hex.substring(0, 2), 16)
  let g = parseInt(hex.substring(2, 4), 16)
  let b = parseInt(hex.substring(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const TwoDimensional = (arr: any[], size: number) => {
  let res = []
  for (let i = 0; i < arr.length; i = i + size) res.push(arr.slice(i, i + size))

  return res
}

export const TwoDimensionalDataMapper = (Data: any[], numberOfCol: number) => {
  const colArray = Array.from(new Array(numberOfCol), function () {
    return []
  })

  const twoDimenData = TwoDimensional([...Data], numberOfCol)

  twoDimenData.forEach(d => {
    return d.forEach((data, index) => {
      colArray[index].push(data)
    })
  })

  return colArray
}

export const delay = (time: number) => {
  return new Promise((resolve, rej) => {
    setTimeout(() => {
      resolve(0)
    }, time)
  })
}

export const getFilteredStory = (storyId: string, stories: any[]) => {
  const filteredStory = stories.filter(({ id }) => id == storyId)

  return filteredStory[0]
}

export const getTitleFilteredStory = (title: string, stories: any[]) => {
  const filteredStory = stories.filter(
    ({ project }) => encodeURIComponent(title) === convertIntoDashedString(project.portfolioItemName),
  )

  return filteredStory[0]
}

export const getStoryTitleBySlug = async (stories: any[], id: string) => {
  const filteredStory = stories.filter(({ storyId }) => storyId === id)
  return filteredStory && filteredStory.length > 0
    ? encodeURIComponent(convertIntoDashedString(filteredStory[0].topBannerData.title))
    : null
}

// export const getData = async function () {
// 	// export const getData = cache(async function (source = "render") {
// 	const res = await fetch(`https://stories-render-test-git-dev-ratiomarks-projects.vercel.app//api/master`, {
// 		next: { tags: ["showcase"] },
// 	})

// 	if (!res.ok) {
// 		throw new Error(`Failed to fetch master data, status: ${res.status}`)
// 	}

// 	// Итоговый JSON, в котором уже есть все merge-результаты
// 	const data = await res.json()
// 	return data
// }
export const getData = cache(async function () {
  // export const getData = cache(async function (source = "render") {
  // console.log(`getData - start `)
  // console.log(`getData - start ${source}`)
  const data = await fetchData()
  // console.log(`getData - end `)
  const portfolio = data && data.length > 0 ? data[0] : null

  return portfolio
})
export const getDataUpdated = cache(async function () {
  // export const getData = cache(async function (source = "render") {
  // console.log(`getData - start `)
  // console.log(`getData - start ${source}`)
  const data = await fetchData()
  // console.log(`getData - end `)
  const portfolio = data && data.length > 0 ? data[0] : null

  return portfolio
})
// export async function getData(source = "render") {
// 	console.log(`getData - start ${source}`)
// 	const data = await fetchData()
// 	// console.log( JSON.stringify(data, null, 2))
// 	console.log(`getData - end ${source}`)
// 	const portfolio = data && data.length > 0 ? data[0] : null

// 	return portfolio
// }

export async function getFonts(data: any[]) {
  const fonts = [...new Set(data.flatMap(item => [item.metaData.seo.font1, item.metaData.seo.font2]))]
  const res = fonts.filter(Boolean)
  // console.log(JSON.stringify(res, null, 2))
  return res
  // return fonts.filter(Boolean)
}

export const setFavicon = function (url: string) {
  const favicon = document.querySelector('link[rel="icon"]')
  if (favicon) {
    favicon.href = url
  } else {
    const link = document.createElement('link')
    link.rel = 'icon'
    link.href = url
    document.head.appendChild(link)
  }
}
// export async function myFetch<T>(endpoint: string): Promise<T> {
export function deepClone<T>(data: T): T {
  return JSON.parse(JSON.stringify(data))
}

export const isBrowser = () => typeof window !== 'undefined'

function isValidUUID(uuid: string) {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  return uuidRegex.test(uuid)
}

export const fetchStoryData = cache(async function (storyId: string) {
  // 1) Готовим список эндпоинтов
  const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL
  const full_link = `${NEXT_PUBLIC_BASE_URL}/render`
  const endpoints = [`${full_link}/filterData`]

  // Если UUID, добавляем запрос на конкретный storyId
  if (isValidUUID(storyId)) {
    endpoints.push(`${full_link}/${storyId}`)
  }

  // 2) Запускаем параллельные фетчи – IMPORTANT: проставим { next: { tags: ["showcase"] } }
  const fetchEndpoints = endpoints.map(async endpoint => {
    const response = await fetch(endpoint, {
      // cache: "no-cache",           //  Убираем no-cache, чтобы включить кэширование
      next: { tags: ['showcase'] }, //  Привязываем к тегу showcase
    })
    if (!response.ok) {
      throw new Error(`Network response was not ok for: ${endpoint}`)
    }
    return response.json()
  })

  try {
    // 3) Собираем результаты
    const result = await Promise.allSettled(fetchEndpoints)
    const newResult = result.map(d => (d.status === 'fulfilled' ? { ...d.value } : {}))

    // newResult[0] = filterData
    // Подмешиваем локальные oldFilters в индекс 1
    newResult.splice(1, 0, oldFilters)

    // newResult[2] = либо {}, либо ответ c бэка (если UUID)
    if (!isValidUUID(storyId)) {
      // Подмешиваем локальные данные
      newResult[2] = allOldStoriesById[storyId] || {}
    }

    // 4) Подмешиваем список опубликованных компаний (тоже привязываем к showcase)
    const publishedStoriesCompanyList = await fetchCompanyList(/* { next: { tags: ["showcase"] } } */)

    // Сливаем поля
    newResult[0] = {
      industries: [...(newResult[0]?.industries || []), ...(newResult[1]?.Industry || [])],
      technologies: [...(newResult[0]?.technologies || []), ...(newResult[1]?.Technologies || [])],
      companies: [...(publishedStoriesCompanyList || []), ...(newResult[1]?.Company || [])],
    }

    // 5) Определяем, как обрабатывать newResult[2]
    newResult[2] = isValidUUID(storyId)
      ? singleStoryDataFormatter(newResult[2])
      : restructureOldStoriesData(newResult[2])

    // 6) Финальное форматирование
    const rawformattedData = dataFormatter(newResult)
    const formattedData = dataFormatterForShowcase(rawformattedData)

    // 7) Возвращаем первую запись (обычно formattedData[0])
    return formattedData[0] || null
  } catch (error) {
    console.error('fetchStoryData error:', error)
    return null
  }
})

const singleStoryDataFormatter = (data: any) => {
  return [
    {
      stories: [{ ...data.story }],
      design: data.design,
    },
  ]
}
export async function myFetch<T>(endpoint: string): Promise<T> {
  const response = await fetch(endpoint, {
    next: { tags: ['showcase'] },
  })
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return response.json() as Promise<T>
}

const fetchCompanyList = async (): Promise<string[]> => {
  const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL
  const full_link = `${NEXT_PUBLIC_BASE_URL}/render/companyNamesWithPublishedStories`

  const response = await fetch(full_link, {
    next: { tags: ['showcase'] },
  })
  if (!response.ok) {
    return []
  }

  return response.json()
}

export async function fetchStoriesForShowcase(companyIds: string[]): Promise<StoryPublishedRenderDtoResponse[] | null> {
  const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL
  const full_link = `${NEXT_PUBLIC_BASE_URL}/render/publishedStoriesByCompanyId`

  const fetchEndpoints = companyIds.map(async companyId => {
    const response = await fetch(`${full_link}/${companyId}`, {
      next: { tags: ['showcase', companyId] },
    })

    if (!response.ok) {
      throw new Error('Network response was not ok')
    }

    // Приводим к типу StoryPublishedRenderDtoResponse
    return response.json() as Promise<StoryPublishedRenderDtoResponse>
  })

  try {
    // Promise.allSettled: каждый промис либо fulfilled, либо rejected
    const settled = await Promise.allSettled<StoryPublishedRenderDtoResponse>(fetchEndpoints)

    // Выбираем результаты, которые в статусе fulfilled
    const data: StoryPublishedRenderDtoResponse[] = settled
      .filter(res => res.status === 'fulfilled')
      .map(res => (res as PromiseFulfilledResult<StoryPublishedRenderDtoResponse>).value)

    return data
  } catch (error) {
    console.error('Error fetching data:', error)
    return null
  }
}
export async function fetchData() {
  const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL
  const full_link = `${NEXT_PUBLIC_BASE_URL}/render`

  try {
    const filterData = await myFetch<FilterDataFromApi>(`${full_link}/filterData`)
    // console.log(JSON.stringify(filterData, null, 2))
    const companyIdList = await myFetch<string[]>(`${full_link}/getCompanyIdsWithPublishedStories`)
    const industries = [...filterData.industries, ...oldFilters.Industry]
    const technologies = [...(filterData?.technologies ?? []), ...oldFilters.Technologies]
    const storiesFetchedFromApi = (await fetchStoriesForShowcase(companyIdList)) ?? []
    const oldStories = restructureOldStoriesData(allOldData)

    const publishedStoriesCompanyList = await fetchCompanyList()
    const companies = [...publishedStoriesCompanyList, ...oldFilters.Company]

    const mergedFilters = {
      industries,
      technologies,
      companies,
    }

    const publicStories = [...storiesFetchedFromApi, ...oldStories]
    // const combinedForFormatter = [mergedFilters, publicStories]
    const combinedForFormatter = [mergedFilters, [...storiesFetchedFromApi, ...oldStories]]
    const rawFormattedData = dataFormatterUpdated({ filters: mergedFilters, stories: publicStories })
    // const formattedData = dataFormatterForShowcase(rawFormattedData)
    const formattedData = dataFormatterForShowcaseUpdated(rawFormattedData)

    return formattedData
  } catch (error) {
    console.error('Error fetching data:', error)
    return null
  }
}
export async function fetchDataUpdated() {
  const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL
  const full_link = `${NEXT_PUBLIC_BASE_URL}/render`

  try {
    const filterData = await myFetch<FilterDataFromApi>(`${full_link}/filterData`)
    const companyIdList = await myFetch<string[]>(`${full_link}/getCompanyIdsWithPublishedStories`)
    const industries = [...filterData.industries, ...oldFilters.Industry]
    const technologies = [...(filterData.technologies ?? []), ...oldFilters.Technologies]
    const storiesFetchedFromApi = (await fetchStoriesForShowcase(companyIdList)) ?? []
    const oldStories = restructureOldStoriesData(allOldData)

    const publishedStoriesCompanyList = await fetchCompanyList()
    const companies = [...publishedStoriesCompanyList, ...oldFilters.Company]

    const mergedFilters = {
      industries,
      technologies,
      companies,
    }

    const publicStories = [...storiesFetchedFromApi, ...oldStories]
    // const combinedForFormatter = [mergedFilters, publicStories]
    const combinedForFormatter = [mergedFilters, [...storiesFetchedFromApi, ...oldStories]]
    const filters = getFiltersDataUpdated(mergedFilters)
    const rawFormattedData = dataFormatterUpdatedV2({ stories: storiesFetchedFromApi })
    // let filePath = path.join(process.cwd(), 'a-old.json')
    // await fs.writeFile(filePath, JSON.stringify(oldStories, null, 2))
    // filePath = path.join(process.cwd(), 'a-new.json')
    // await fs.writeFile(filePath, JSON.stringify(rawFormattedData, null, 2))
    // const rawFormattedData = dataFormatterUpdatedV2({ stories: publicStories })
    // const formattedData = dataFormatterForShowcase(rawFormattedData)
    const formattedData = dataFormatterForShowcaseUpdated(rawFormattedData)

    return formattedData
  } catch (error) {
    console.error('Error fetching data:', error)
    return null
  }
}

export const dataFormatterForShowcaseUpdated = (data: Portfolio[]) => {
  const cards: Card[] = []
  const stories: StoryFormatted[] = []
  const existingTechnologiesList: string[] = []
  // const existingTechnologies = new Set()
  // const newData = {
  // 	// stories: [],
  // 	// cards: [],
  // 	filters: { ...data[0].filters },
  // 	metaData: { ...data[0].metaData },
  // }
  data.forEach(d => {
    // newData.stories.push(...d.stories)
    stories.push(...d.stories)
    cards.push(...d.cards)
    // cards.push(...d.cards.sort((a, b) => Date.parse(b?.createdAt ?? '') - Date.parse(a?.createdAt ?? '')))
    // console.log(d.cards.flatMap(card => card.filterValues.Technologies).forEach(tech => existingTechnologies.add(tech)))
    // existingTechnologies.add(d.cards.flatMap(card => card.filterValues.Technologies))
    // d.cards.flatMap(card => card.filterValues.Technologies).forEach(tech => existingTechnologies.add(tech))
    // existingTechnologies.add(d.cards.flatMap(card => card.filterValues.Technologies))
    // newData.cards.push(...d.cards)
  })
  cards.forEach(card => {
    existingTechnologiesList.push(...card['filterValues']['Technologies'])
  })
  const s = new Set(existingTechnologiesList)
  // const technologies = data[0].filters.Technologies.filter(tech => existingTechnologies.has(tech))
  const newData = {
    stories,
    cards,
    filters: {
      Technologies: Array.from(s).sort(),
      Company: data[0].filters['Company'].sort(),
      Industry: data[0].filters['Industry'].sort(),
    },
    metaData: { ...data[0].metaData },
  }
  let newArray: Portfolio[] = []
  newArray.push(newData)

  return newArray
}
export const dataFormatterForShowcaseUpdatedV2 = (data: Portfolio[]) => {
  const cards: Card[] = []
  const stories: Record<string, StoryFormatted[]> = {}
  // const newData = {
  // 	// stories: [],
  // 	// cards: [],
  // 	filters: { ...data[0].filters },
  // 	metaData: { ...data[0].metaData },
  // }
  data.forEach(d => {
    // newData.stories.push(...d.stories)
    stories.push(...d.stories)
    cards.push(...d.cards)
    // newData.cards.push(...d.cards)
  })
  const newData = {
    stories,
    cards,
    filters: { ...data[0].filters },
    metaData: { ...data[0].metaData },
  }
  let newArray: Portfolio[] = []
  newArray.push(newData)

  return newArray
}
export const dataFormatterForShowcase = data => {
  const newData = {
    stories: [],
    cards: [],
    filters: { ...data[0].filters },
    metaData: { ...data[0].metaData },
  }
  data.forEach(d => {
    newData.stories.push(...d.stories)
    newData.cards.push(...d.cards)
  })
  let newArray = []
  newArray.push(newData)

  return newArray
}
interface ApiData {
  filters: {
    industries: string[]
    technologies: string[]
    companies: string[]
  }
  stories: (StoryPublishedRenderDtoResponse | RestructuredOldStoriesDataItem)[]
}
export const dataFormatterUpdated = ({ filters, stories }: ApiData) => {
  // const data = [...apiData]
  // const Filters = getFiltersData(deepClone(filters))
  const Filters = getFiltersDataUpdated(deepClone(filters))
  const publicStories = stories
  const newData: Portfolio[] = []
  publicStories.forEach(storiesWithDesignObject => {
    // console.log(portfolioData)
    if (storiesWithDesignObject.stories.length === 0) return
    const portfolioData = getPortFolioDataUpdated(deepClone(storiesWithDesignObject), Filters)
    newData.push(portfolioData)
  })

  return newData
}
export const dataFormatterUpdatedV2 = ({ stories }: { stories: StoryPublishedRenderDtoResponse[] }) => {
  // const data = [...apiData]
  // const Filters = getFiltersData(deepClone(filters))
  // const publicStories = stories
  const newData: Portfolio[] = []
  // console.log('stories', stories.length)
  // console.log('stories', stories.length)
  // console.log('stories', stories.length)
  stories.forEach(storiesWithDesignObject => {
    // storiesWithDesignObject.stories.forEach((story) => {
    // 	if (story?.isSalesforce) {
    // 		console.log('story', story.id)
    // 	}
    // })
    // if (!('design' in storiesWithDesignObject)) {
    // 	console.log('storiesWithDesignObject', storiesWithDesignObject)
    // } else {
    // 	console.log('@@@@@@@@@@@@@@@@@@@')
    // }
    if (storiesWithDesignObject.stories.length === 0) return
    const portfolioData = getPortFolioDataUpdatedV2(deepClone(storiesWithDesignObject))
    newData.push(portfolioData)
  })

  return newData
}
// export const dataFormatterUpdatedV32 = ({ stories }: { stories: (StoryPublishedRenderDtoResponse | RestructuredOldStoriesDataItem)[] }) => {
// 	// const data = [...apiData]
// 	// const Filters = getFiltersData(deepClone(filters))
// 	// const publicStories = stories
// 	const newData: Portfolio[] = []
// 	console.log('stories', stories.length)
// 	console.log('stories', stories.length)
// 	console.log('stories', stories.length)
// 	stories.forEach((storiesWithDesignObject) => {
// 		storiesWithDesignObject.stories.forEach((story) => {
// 			if (story?.isSalesforce) {
// 				console.log('story', story.id)
// 			}
// 		})
// 		if (!('design' in storiesWithDesignObject)) {
// 			console.log('storiesWithDesignObject', storiesWithDesignObject)
// 		} else {
// 			console.log('@@@@@@@@@@@@@@@@@@@')
// 		}
// 		if (storiesWithDesignObject.stories.length === 0) return
// 		const portfolioData = getPortFolioDataUpdatedV2(deepClone(storiesWithDesignObject))
// 		newData.push(portfolioData)
// 	})

// 	return newData
// }

export const dataFormatter = apiData => {
  const data = [...apiData]
  const Filters = getFiltersData(deepClone(data[0]))
  const publicStories = data[1]
  const newData = []
  publicStories.forEach(singlePortfolio => {
    // console.log(portfolioData)
    if (singlePortfolio.stories.length === 0) return
    const portfolioData = getPortFolioData(deepClone(singlePortfolio), Filters)
    newData.push(portfolioData)
  })

  return newData
}
const getFiltersDataUpdated = (filters: ApiData['filters']): FilterValuesObject => {
  const defaultNavItems = ['Industry', 'Technologies', 'Company']

  const filterData = {
    Industry: filters.industries,
    Technologies: [...technologies, ...(filters?.technologies ?? [])],
    Company: filters.companies ?? [],
  }

  return filterData
}
const getFiltersData = filters => {
  const defaultNavItems = ['Industry', 'Technologies', 'Company']

  const filterData = {
    Industry: filters.industries,
    Technologies: [...technologies, ...filters?.technologies],
    Company: filters.companies,
  }

  Object.keys(filterData).forEach(item => {
    if (!defaultNavItems.includes(item)) {
      delete filterData[item]
    }
  })

  Object.keys(filterData).forEach(key => {
    filterData[key] = [...new Set(filterData[key])]
  })

  return filterData
}

const getPortFolioDataUpdated = (
  data: StoryPublishedRenderDtoResponse,
  filters: FilterValuesObject,
  authStatus = 'public',
): Portfolio => {
  const metaData = getPortfolioMetaData(data, authStatus)
  const newData = {
    metaData,
    filters,
    stories: getPortFolioStories(data, metaData),
    // stories: getPortFolioStories(data, metaData),
    cards: getPortFolioCardsUpdated(data),
  }
  // newData.metaData = getPortfolioMetaData(data, authStatus)
  // const filters = { ...filters }
  // newData.filters = { ...filters }
  // const stories = getPortFolioStories(data, metaData)
  // newData.stories = getPortFolioStories(data, newData.metaData)
  // newData.cards = getPortFolioCards(data)

  return newData
}

export interface PortfolioUpdatedV2 {
  stories: { [storyId: string]: StoryFormatted[] }
  cards: Card[]
  metaData: any
}
// const getPortFolioDataUpdatedV2 = (data: StoryPublishedRenderDtoResponse | RestructuredOldStoriesDataItem): Portfolio => {
const getPortFolioDataUpdatedV2 = (data: StoryPublishedRenderDtoResponse): Portfolio => {
  const metaData = getPortfolioMetaData(data, 'public')
  const newData = {
    metaData,
    stories: getPortFolioStoriesV2(data, metaData),
    // stories: getPortFolioStories(data, metaData),
    cards: getPortFolioCardsUpdated(data),
  }
  // newData.metaData = getPortfolioMetaData(data, authStatus)
  // const filters = { ...filters }
  // newData.filters = { ...filters }
  // const stories = getPortFolioStories(data, metaData)
  // newData.stories = getPortFolioStories(data, newData.metaData)
  // newData.cards = getPortFolioCards(data)

  return newData
}
const getPortFolioDataSalesforceUpdated = (
  data: RestructuredOldStoriesDataItem,
  filters: FilterValuesObject,
  authStatus = 'public',
): Portfolio => {
  const metaData = getPortfolioMetaData(data, authStatus)
  const newData = {
    metaData,
    filters,
    stories: getPortFolioStories(data, metaData),
    // stories: getPortFolioStories(data, metaData),
    cards: getPortFolioCardsUpdated(data),
  }
  // newData.metaData = getPortfolioMetaData(data, authStatus)
  // const filters = { ...filters }
  // newData.filters = { ...filters }
  // const stories = getPortFolioStories(data, metaData)
  // newData.stories = getPortFolioStories(data, newData.metaData)
  // newData.cards = getPortFolioCards(data)

  return newData
}
const getPortFolioData = (data, filters, authStatus = 'public') => {
  const newData = {}
  newData.metaData = getPortfolioMetaData(data, authStatus)
  newData.filters = { ...filters }
  newData.stories = getPortFolioStories(data, newData.metaData)
  newData.cards = getPortFolioCards(data)

  return newData
}

export const getSalesForcePortFolioData = (data: SingleCompanyResultSalesForce, authStatus = 'public') => {
  const metaData = getSalesForcePortfolioMetaData(data, authStatus)
  const stories = getSalesforcePortFolioStories(data, metaData)
  return { metaData, stories }
}
const getPortfolioMetaData = (data: StoryPublishedRenderDtoResponse, authStatus = 'public') => {
  const stories = data?.stories
  const design = data?.design
  const { websiteUrl, primaryFontType, secondaryFontType, logoImageUrl, contactUsLinkUrl } = design
  const { seo, project } = stories[0]
  const newData: ApiMetaData = {
    general: {
      title: project.portfolioItemName || '',
      logo: logoImageUrl || '',
      fav_image: '',
      contact_us: contactUsLinkUrl || '',
      account_description: '',
      website: websiteUrl || '',
      faviconimage: '',
    },
    theme: getTheme(design),
    seo: {
      title: seo?.metaName || '',
      image: '',
      // image: seo?.logo || '',
      description: seo?.metaDescription || '',
      font1: primaryFontType || 'Poppins',
      font2: secondaryFontType || 'Poppins',
    },
    // trackingIds: {
    // 	hubSpot: {
    // 		id: '',
    // 		domain: '',
    // 	},
    // 	pi: {
    // 		host: '',
    // 		aId: '',
    // 		cId: '',
    // 	},
    // 	zoomInfo: {
    // 		id: '',
    // 	},
    // 	qualifiedChatBot: {
    // 		token: '',
    // 	},
    // 	linkedinInsight: {
    // 		id: '2552fqwff23r',
    // 	},
    // 	googleAnalytics: {
    // 		clientId: '',
    // 		brightrId: '',
    // 	},
    // },
    // auth: {
    // 	status: authStatus,
    // 	email: '',
    // 	password: '',
    // },
  }

  return newData
}

const getSalesforcePortFolioStories = (data: SingleCompanyResultSalesForce, metaData: SalesforceMetaData) => {
  const updated = data.stories.map(story => {
    const updatedMetadata = deepClone(metaData)
    updatedMetadata.seo.title = story.topBannerData.title
    updatedMetadata.seo.description = story.topBannerData.description
    updatedMetadata.seo.image = story.topBannerData.logoSrc
    updatedMetadata.general.logo = story.header.imagesSrc.logoSrc
    updatedMetadata.theme = getSalesForceTheme(story)
    // updatedMetadata.trackingIds.campaign.campaignName = story.trackingData.campaignName
    // updatedMetadata.trackingIds.campaign.campaignLandingPageUrl = story.trackingData.campaignLandingPageUrl
    return { metaData: updatedMetadata, id: story.storyId, ...story }
  })
  return updated
}

const getSalesForcePortfolioMetaData = (data: SingleCompanyResultSalesForce, authStatus: string) => {
  const {
    website,
    piHostname,
    piAId,
    piCId,
    trackingData,
    linkedinPartnerId,
    faviconimage,
    primaryfont,
    secondaryfont,
    calendlyLink: meeting_link,
  } = data.stories[0]
  const { title, logo, fav_image, contact_us, account_description } = data
  const salesForceMetaData: SalesforceMetaData = {
    general: {
      title,
      logo,
      fav_image,
      contact_us,
      account_description,
      website,
      faviconimage,
      meeting_link,
    },
    seo: {
      title: data.metadataName,
      image: data.logo,
      description: data.metadataDescription,
      font1: primaryfont,
      font2: secondaryfont,
    },
    theme: getSalesForceTheme(data.stories[0]),
    // trackingIds: {
    // 	hubSpot: {
    // 		id: trackingData?.hubSpotId || '',
    // 		domain: trackingData?.hubSpotDomain || '',
    // 	},
    // 	campaign: {
    // 		campaignName: trackingData?.campaignName || '',
    // 		campaignLandingPageUrl: trackingData?.campaignLandingPageUrl,
    // 	},
    // 	pi: {
    // 		host: piHostname || '',
    // 		aId: piAId || '',
    // 		cId: piCId || '',
    // 	},
    // 	zoomInfo: {
    // 		id: '',
    // 	},
    // 	qualifiedChatBot: {
    // 		token: '',
    // 	},
    // 	linkedinInsight: {
    // 		id: linkedinPartnerId || '2552fqwff23r',
    // 	},
    // 	googleAnalytics: {
    // 		clientId: trackingData?.clientGoogleTrackingId || '',
    // 		brightrId: trackingData?.brightrGoogleTrackingId || '',
    // 	},
    // },
    // auth: {
    // 	status: authStatus,
    // 	email: '',
    // 	password: '',
    // },
  }

  return salesForceMetaData
}
const getPortFolioStories = (
  data: StoryPublishedRenderDtoResponse | RestructuredOldStoriesDataItem,
  metaData: ApiMetaData,
) => {
  // const getPortFolioStories = (data, metaData) => {
  const stories = data.stories
  const updated = stories.map(story => {
    const updatedMetaData = deepClone(metaData)
    const seoEssential = { title: story?.seo?.metaName ?? '', description: story?.seo?.metaDescription ?? '' }
    const seo = { ...updatedMetaData.seo, ...seoEssential }
    const newMetaData: ApiMetaData = {
      ...updatedMetaData,
      seo,
      theme: getTheme(data?.design),
    }
    const seoChecked = { metaName: story?.seo?.metaName ?? '', metaDescription: story?.seo?.metaDescription ?? '' }
    // updatedMetaData.seo.title = story?.seo?.metaName ?? ''
    // updatedMetaData.seo.description = story?.seo?.metaDescription ?? ''
    // updatedMetaData.theme = getTheme(data.design)
    const res: StoryFormatted = { metaData: newMetaData, ...story, seo: seoChecked }
    // return { metaData: updatedMetaData, ...story }
    return res
    // const updatedMetaData = deepClone(metaData)
    // updatedMetaData.seo.title = story?.seo?.metaName ?? ''
    // updatedMetaData.seo.description = story?.seo?.metaDescription ?? ''
    // updatedMetaData.theme = getTheme(data.design)
    // const res = { metaData: updatedMetaData, ...story } satisfies StoryFormatted
    // return { metaData: updatedMetaData, ...story }
  })

  return updated
}
const getPortFolioStoriesV2 = (
  data: StoryPublishedRenderDtoResponse | RestructuredOldStoriesDataItem,
  metaData: ApiMetaData,
) => {
  // const getPortFolioStories = (data, metaData) => {
  const stories = data.stories
  const updated = stories.map(story => {
    const updatedMetaData = deepClone(metaData)
    const seoEssential = { title: story?.seo?.metaName ?? '', description: story?.seo?.metaDescription ?? '' }
    const seo = { ...updatedMetaData.seo, ...seoEssential }
    const newMetaData: ApiMetaData = {
      ...updatedMetaData,
      seo,
      theme: getThemeV2(data?.design),
    }
    const seoChecked = { metaName: story?.seo?.metaName ?? '', metaDescription: story?.seo?.metaDescription ?? '' }
    // updatedMetaData.seo.title = story?.seo?.metaName ?? ''
    // updatedMetaData.seo.description = story?.seo?.metaDescription ?? ''
    // updatedMetaData.theme = getTheme(data.design)
    const res: StoryFormatted = { metaData: newMetaData, ...story, seo: seoChecked }
    // const res: StoryFormatted = { metaData: newMetaData, ...story, seo: seoChecked }
    // return { metaData: updatedMetaData, ...story }
    return res
    // const updatedMetaData = deepClone(metaData)
    // updatedMetaData.seo.title = story?.seo?.metaName ?? ''
    // updatedMetaData.seo.description = story?.seo?.metaDescription ?? ''
    // updatedMetaData.theme = getTheme(data.design)
    // const res = { metaData: updatedMetaData, ...story } satisfies StoryFormatted
    // return { metaData: updatedMetaData, ...story }
  })

  return updated
}
// const getPortFolioStories = (data: StoryPublishedRenderDtoResponse | RestructuredOldStoriesDataItem, metaData: ApiMetaData) => {
// 	// const getPortFolioStories = (data, metaData) => {
// 	const stories = data.stories
// 	const updated = stories.map((story) => {
// 		const updatedMetaData = deepClone(metaData)
// 		const seoEssential = { title: story?.seo?.metaName ?? '', description: story?.seo?.metaDescription ?? '' }
// 		const seo = { ...updatedMetaData.seo, ...seoEssential }
// 		const newMetaData: ApiMetaData = {
// 			...updatedMetaData,
// 			seo,
// 			theme: getTheme(data.design),
// 		}
// 		const seoChecked = { metaName: story?.seo?.metaName ?? '', metaDescription: story?.seo?.metaDescription ?? '' }
// 		// updatedMetaData.seo.title = story?.seo?.metaName ?? ''
// 		// updatedMetaData.seo.description = story?.seo?.metaDescription ?? ''
// 		// updatedMetaData.theme = getTheme(data.design)
// 		const res: StoryFormatted = { metaData: newMetaData, ...story, seo: seoChecked }
// 		// return { metaData: updatedMetaData, ...story }
// 		return res
// 		// const updatedMetaData = deepClone(metaData)
// 		// updatedMetaData.seo.title = story?.seo?.metaName ?? ''
// 		// updatedMetaData.seo.description = story?.seo?.metaDescription ?? ''
// 		// updatedMetaData.theme = getTheme(data.design)
// 		// const res = { metaData: updatedMetaData, ...story } satisfies StoryFormatted
// 		// return { metaData: updatedMetaData, ...story }
// 	})

// 	return updated
// }
// const getPortFolioStories = (data: StoryPublishedRenderDtoResponse, metaData: ApiMetaData) => {
// // const getPortFolioStories = (data, metaData) => {
// 	const stories = data.stories
// 	const updated = stories.map((story) => {
// 		const updatedMetaData = deepClone(metaData)
// 		updatedMetaData.seo.title = story?.seo?.metaName
// 		updatedMetaData.seo.description = story?.seo?.metaDescription
// 		updatedMetaData.theme = getTheme(data.design)

// 		return { metaData: updatedMetaData, ...story }
// 	})

// 	return updated
// }
const getPortFolioCardsUpdated = (data: StoryPublishedRenderDtoResponse): Card[] => {
  const stories = data.stories
  const newData: Card[] = []

  stories.forEach(storyItem => {
    newData.push({
      companyLogo: data.design.logoImageUrl,
      createdAt: storyItem.createdAt,
      companyName: storyItem.project.portfolioItemName,
      isFeedbackValidated: storyItem?.isFeedbackValidated,
      imageSrc: storyItem.project.storyImageUrl,
      imageTitle: storyItem.project.portfolioItemName
        ? storyItem.project.portfolioItemName
        : 'Story Lorem Dolor Amet Nullum Consecutir Voluptat',
      StoryTitle: storyItem.project.portfolioItemName
        ? storyItem.project.portfolioItemName
        : 'Story Lorem Dolor Amet Nullum Consecutir Voluptat',
      StoryDescription: storyItem.project.description,
      filterValues: {
        Company: storyItem.companyName,
        Industry: storyItem.project.industry,
        Technologies: storyItem.technologies.map(t => t.name),
      },
      storyId: storyItem.id,
      // isSalesforce: storyItem?.isSalesforce ?? false,
      isSalesforce: false,
      date: storyItem.createdAt,
      isFeatured: storyItem.isFeatured,
      storyURL: `/Brightr-Showcase/${convertIntoDashedString(storyItem.companyName)}/${storyItem.id}`,
    })
  })

  return newData
}

const getPortFolioCards = data => {
  const stories = data.stories
  const newData = []

  stories.forEach(card => {
    newData.push({
      companyName: card.project.portfolioItemName,
      companyLogo: data.design.logoImageUrl,
      createdAt: card?.createdAt,
      imageSrc: card.project.storyImageUrl,
      imageTitle: card.project.portfolioItemName
        ? card.project.portfolioItemName
        : 'Story Lorem Dolor Amet Nullum Consecutir Voluptat',
      StoryTitle: card.project.portfolioItemName
        ? card.project.portfolioItemName
        : 'Story Lorem Dolor Amet Nullum Consecutir Voluptat',
      StoryDescription: card.project.description,
      filterValues: {
        Company: card.companyName,
        Industry: card.project.industry,
        Technologies: card.technologies.map(t => t.name),
      },
      storyId: card.id,
      isSalesforce: card.isSalesforce ?? false,
      date: card.createdAt,
      isFeatured: card.isFeatured,
      storyURL: `/Brightr-Showcase/${convertIntoDashedString(card.companyName)}/${card.id}`,
    })
  })

  return newData
}

const getTheme = (design: DesignRenderDto): ApiTheme => {
  const theme = {
    fontFamilyPrimary: `"${design.primaryFontType}"` || 'Poppins',
    fontFamilySecondary: `"${design.secondaryFontType}"` || 'Poppins',
    generalBackgroundColor: design.generalBackgroundColor || '#FFFFFF',
    primaryCoverFontColor: design.primaryCoverFontColor || '#FFFFFF',
    primaryFontColor: design.primaryFontColor || '#474848',
    secondaryFontColor: design.secondaryFontColor || '#484a4a',
    accentBackgroundColor: design.accentBackgroundColor || '#535454',
    accentPrimaryFontColor: design.accentPrimaryFontColor || '#9f9d9d',
    accentSecondaryFontColor: design.accentSecondaryFontColor || '#cacccc',
    coverBackgroundColor: design.coverBackgroundColor || '#636363',
    websiteUrl: design.websiteUrl,
    contactUsLinkUrl: design.contactUsLinkUrl,
    logoImageUrl: design.logoImageUrl,
    storyPageBannerImageUrl: design.storyPageBannerImageUrl,
  }

  return theme
}
const getThemeV2 = (design: DesignRenderDto | RestructureDesign): ApiTheme => {
  const theme = {
    fontFamilyPrimary: `"${design.primaryFontType}"` || 'Poppins',
    fontFamilySecondary: `"${design.secondaryFontType}"` || 'Poppins',
    generalBackgroundColor: design.generalBackgroundColor || '#FFFFFF',
    primaryCoverFontColor: design.primaryCoverFontColor || '#FFFFFF',
    primaryFontColor: design.primaryFontColor || '#474848',
    secondaryFontColor: design.secondaryFontColor || '#484a4a',
    accentBackgroundColor: design.accentBackgroundColor || '#535454',
    accentPrimaryFontColor: design.accentPrimaryFontColor || '#9f9d9d',
    accentSecondaryFontColor: design.accentSecondaryFontColor || '#cacccc',
    coverBackgroundColor: design?.coverBackgroundColor ?? '#636363',
    websiteUrl: design.websiteUrl,
    contactUsLinkUrl: design.contactUsLinkUrl,
    logoImageUrl: design.logoImageUrl,
    storyPageBannerImageUrl: design.storyPageBannerImageUrl,
  }

  return theme
}

const getSalesForceTheme = (story: StoryRawFromSalesForce) => {
  const theme = {
    sbgColor: story.bgcolor || '#FFFFFF',
    primaryColor: story.primarycolor || '#02BBA7',
    secondaryColor: story.secondarycolor || '#B4DFE6',
    primaryTextColor: story.primaryfontcolor || '#312D59',
    secondaryTextColor: story.secondaryfontcolor || '#87899F',
    lineColor: story.linecolor || '02BBA7',
    fontFamilyPrimary: `"${story.primaryfont}"` || 'Poppins',
    fontFamilySecondary: `"${story.secondaryfont}"` || 'Poppins',
    secondaryheaderfontcolor: story.secondaryheaderfontcolor || 'FFFFFF',
  }

  return theme
}

export const getSubscriptionData = async (email: string) => {
  try {
    const url = `${process.env.NEXT_PUBLIC_SALESFORCE_URL}/webservices/services/apexrest/brightrmagazinesubscription/${email}`

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      throw new Error('Network response was not ok: ' + response.statusText)
    }

    return response.json()
  } catch (err) {
    console.log(err)
  }
}

// let crumbs = {
//   parentSite: {
//     label: publicData[0].title,
//     pathname: allStoriesData[0].website,
//     isLocal: false,
//   },
//   root: {
//     label: allStoriesData[0].breadcrumbslabel || "Home",
//     pathname: "/",
//     isLocal: true,
//   },
//   stories: [],
// }

// allStoriesData.forEach((d, i) => {
//   let singleCrumbObject = {}
//   singleCrumbObject.label = d.topBannerData.title
//   singleCrumbObject.isLocal = true
//   crumbs.stories.push(singleCrumbObject)
// })

// const breadcrumbs = useMemo(() => {
//   return crumbs
// }, [])

// const fetchCompanyList3 = async () => {
// 	const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL
// 	const full_link = `${NEXT_PUBLIC_BASE_URL}/render/companyNamesWithPublishedStories`

// 	const response = await fetch(full_link, {
// 		next: { tags: ['showcase'] },
// 	})
// 	if (!response.ok) {
// 		return []
// 	}

// 	return response.json()
// }

// const fetchStoriesForShowcase3 = async (data: any) => {
// 	const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL
// 	const full_link = `${NEXT_PUBLIC_BASE_URL}/render/publishedStoriesByCompanyId/`
// 	const endpoints = Object.values(data.pop())

// 	const fetchEndpoints = endpoints.map(async (endpoint) => {
// 		const response = await fetch(full_link + endpoint, {
// 			next: { tags: ['showcase', endpoint] },
// 		})

// 		if (!response.ok) {
// 			throw new Error('Network response was not ok')
// 		}

// 		return response.json()
// 	})

// 	try {
// 		const result = await Promise.allSettled(fetchEndpoints)
// 		const newResult = result
// 			.map((d) => {
// 				return d.status === 'fulfilled' ? { ...d.value } : {}
// 			})
// 			.filter((obj) => Object.keys(obj).length > 0)
// 		data.push(newResult)

// 		return data
// 	} catch (error) {
// 		console.error('Error fetching data:', error)
// 		return null
// 	}
// }
